import { toPracticeAssessmentSearchQuery } from '@hb/react'
import {
  BaseQuery,
  CollectionFilter,
  CollectionSort,
  getPracticeAssessmentCollectionPath,
  PracticeAssessmentData,
  PracticeAssessmentStage,
  practicePregnancyStageFilterFields,
} from '@hb/shared'
import { DataListTab } from '../../../types'
import { getProviderAssessmentColumns } from '../../DataList'
import {
  getAssessmentBackgroundColor,
  getAssessmentDarkBackgroundColor,
  getPostpartumBackgroundColor,
  getPostpartumDarkBackgroundColor,
  nextActionSort,
} from './common'
import { PracticeAssessmentSearchTip } from './search'

const getPracticeAssessmentFilters = (stage: PracticeAssessmentStage | null, archived: boolean) => {
  const filters: CollectionFilter<PracticeAssessmentData>[] = []
  if (stage) {
    filters.push([practicePregnancyStageFilterFields[stage], '==', true])
  }
  filters.push(['archived', '==', archived])
  return filters
}
const getPracticeAssessmentBaseQuery = (
  practiceId: string,
  stage: PracticeAssessmentStage | null,
  archived: boolean,
): BaseQuery<PracticeAssessmentData> => ({
  collection: getPracticeAssessmentCollectionPath(practiceId),
  filters: getPracticeAssessmentFilters(stage, archived),
})

const eddSort: CollectionSort<PracticeAssessmentData> = {
  field: 'edd',
  order: 'asc',
}

export const deliveredOnDescSort: CollectionSort<PracticeAssessmentData> = {
  field: 'deliveredOn',
  order: 'desc',
}

export const getPracticeAssessmentTab = (
  practiceId: string,
  stage: PracticeAssessmentStage | null,
  archived: boolean,
  superAdmin: boolean,
  defaultSort?: CollectionSort<PracticeAssessmentData>,
): DataListTab<PracticeAssessmentData> => ({
  baseQuery: getPracticeAssessmentBaseQuery(practiceId, stage, archived),
  columns: getProviderAssessmentColumns(stage, practiceId, superAdmin, archived),
  defaultSort: defaultSort ?? eddSort,
  secondarySort: nextActionSort,
  toSearchQuery: toPracticeAssessmentSearchQuery,
  searchStringPath: 'stringified',
  itemName: 'Pregnancy',
  searchTip: PracticeAssessmentSearchTip,
  itemHeight: 40,
  rightJustifyTab: archived,
  getItemBackgroundColor:
    stage !== 'Postpartum' ? getPostpartumBackgroundColor : getAssessmentBackgroundColor,
  getItemDarkBackgroundColor:
    stage !== 'Postpartum' ? getPostpartumDarkBackgroundColor : getAssessmentDarkBackgroundColor,
})
